.resizeHandle {
  display: flex;
  user-select: none;
  width: 4px;
  background-color: var(--tuna-palette-primary-main);
  z-index: 1;
  position: absolute;
  align-items: flex-end;
  top: 0;
  height: 100%;
  cursor: col-resize;
}

.resizeHandle--left {
  left: -4px;
}

.resizeHandle--right {
  right: -4px;
}

.resizeHandle:not(.resizeHandle--focused) {
  background-color: transparent;
}

.resizeHandle:not(.resizeHandle--focused):hover {
  background-color: var(--tuna-palette-secondary-main);
}

.resizeHandle--focused {
  background-color: var(--tuna-palette-primary-main);
}

.wrapper {
  display: flex;
}
